import * as types from '../types.js';

export default {

	html: `
		<style>
			/* Modal cabe na viewport: quebra linhas em vez de uma única faixa larga */
			#order.form {
				box-sizing: border-box;
				max-width: min(96vw, 72rem);
				width: 100%;
				min-width: 0;
			}
			#order .fsb {
				flex-wrap: wrap;
				justify-content: flex-start;
				align-items: flex-end;
				gap: var(--space-md) var(--space-lg);
			}
			#order .fsb > label,
			#order .fsb > span {
				flex: 0 1 auto;
				min-width: 0;
			}
			#order .input-order-items-scroll {
				max-width: 100%;
				overflow-x: auto;
			}
			#order #company_id		{ width: 10rem; max-width: 100%; }
			#order #id				{ width: 4.5rem; max-width: 100%; text-align: right;	}
			#order #reference		{ width: 6rem; max-width: 100%; }
			#order #empenho_number	{ width: 11rem; max-width: 100%; }
			#order #receipt_type_id	{ width: min(22rem, 100%); max-width: 100%; }
			#order #created_on		{ width: 9rem; max-width: 100%; }
			#order #created_by		{ width: 8rem; max-width: 100%; }
			#order #updated_on		{ width: 9rem; max-width: 100%; }
			#order #updated_by		{ width: 8rem; max-width: 100%; }
			#order #supplier_id,
			#order #customer_id		{ width: min(20rem, 100%); max-width: 100%; }
			#order #carrier_id		{ width: 14rem; max-width: 100%; }
			#order #program_id		{ width: min(18rem, 100%); max-width: 100%; }
			#order #freight_type	{ width: 10rem; max-width: 100%; }
			#order #freight_value 	{ width: 5rem; max-width: 100%; text-align: right; 	}
			#order #discount 		{ width: 5rem; max-width: 100%; text-align: right;	}
			#order #status	 		{ width: 8rem; max-width: 100%; }
			#order .product 		{ width: 100%; max-width: 28rem; min-width: 10rem; }
			#order .unit 			{ width: 8.5rem; max-width: 100%; }
			#order .quantity 		{ width: 6rem; max-width: 100%; text-align: right;	}
			#order .price 			{ width: 8rem; max-width: 100%; text-align: right;	}
			#order .notes			{ width: 100%; max-width: 100%; }
		</style>
		<form id="order" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="suppliers">
			</datalist>
			<datalist id="customers">
			</datalist>
			<datalist id="carriers">
			</datalist>
			<datalist id="programs">
			</datalist>
			<datalist id="receipt_types">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="units">
			</datalist>
			<datalist id="users">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do pedido">Pedido
					<input id="id" type="text" disabled>
				</label>
				<label title="Código de referência externa">Referência
					<input id="reference" type="text">
				</label>
				<label title="Data e hora de criação do pedido">Data Criação
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Usuário criador do pedido">Criado Por
					<input id="created_by" type="text" list="users" disabled>
				</label>
				<label title="Data e hora de alteração do pedido">Data Alteração
					<input id="updated_on" type="text" disabled>
				</label>
				<label title="Último usuário a alterar o pedido">Alterado Por
					<input id="updated_by" type="text" list="users" disabled>
				</label>
				<label title="Este pedido é uma devolução?">Devolução
					<input id="is_return" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<span id="wrap_supplier_party">
					<label title="Fornecedor do pedido">Fornecedor<sup>*</sup>
						<input id="supplier_id" type="text" list="suppliers" required>
					</label>
				</span>
				<span id="wrap_customer_party" style="display:none">
					<label title="Cliente que devolve (devolução)">Cliente (devolução)<sup>*</sup>
						<input id="customer_id" type="text" list="customers">
					</label>
				</span>
				<label title="Transportador do pedido">Transportador
					<input id="carrier_id" type="text" list="carriers">
				</label>
				<label title="Programa sugerido para a entrada">Programa
					<input id="program_id" type="text" list="programs">
				</label>
				<label title="Número do empenho (Ano + NE + número, ex.: 2025NE02173)">Nº empenho
					<input id="empenho_number" type="text" placeholder="2025NE02173" maxlength="32">
				</label>
				<label title="Tipo de recebimento (cadastro Tipos de Recebimento)">Tipo recebimento
					<input id="receipt_type_id" type="text" list="receipt_types">
				</label>
				<label title="Tipo de frete">Tipo Frete
					<input id="freight_type" type="text" list="freight_types">
				</label>
				<label title="Valor do frete">Valor Frete
					<input id="freight_value" type="text">
				</label>
				<label title="Desconto sobre o valor do pedido">% Desconto
					<input id="discount" type="text">
				</label>
				<label title="Status do pedido">Status<sup>*</sup>
					<input id="status" type="text" list="order_status" value="10" required>
				</label>
			</div>
			<div class="input-order-items-scroll">
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>Unidade<sup>*</sup></th>
							<th>Qtde<sup>*</sup></th>
							<th>Preço Unit<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="Unidade de venda">
								<input id="unit_id-0" class="unit" type="text" list="units" required>
							</td>
							<td title="Quantidade">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
							<td title="Preço unitário do produto">
								<input id="unit_price-0" class="price" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<label class="notes" title="Observações sobre o pedido">Observações
					<textarea id="notes" rows="4"></textarea>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de seleção">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conteúdo das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

		form: 
	{
		selector: '#order',
		partyVisibilitySync(formRoot)
		{
			if (!formRoot) return;
			const ret = formRoot.querySelector('#is_return');
			const ws = formRoot.querySelector('#wrap_supplier_party');
			const wc = formRoot.querySelector('#wrap_customer_party');
			const sup = formRoot.querySelector('#supplier_id');
			const cust = formRoot.querySelector('#customer_id');
			const on = !!(ret && ret.checked);
			if (ws) ws.style.display = on ? 'none' : '';
			if (wc) wc.style.display = on ? '' : 'none';
			if (sup) sup.required = !on;
			if (cust) cust.required = on;
		},
		afterEditSetValues(fs)
		{
			const root = fs?.dialog?.getNode()?.querySelector(this.selector);
			this.partyVisibilitySync(root);
		},
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			formset.loadList('#users', 'users');
			formset.loadList('#programs', 'programs', { labels: ['name'], value: 'id' });
			formset.loadList('#receipt_types', 'receipt_types', { labels: ['code', 'description'], value: 'id' });
			Object.getPrototypeOf(this).init.call(this);
			const root = document.querySelector(this.selector);
			if (root)
			{
				const ret = root.querySelector('#is_return');
				const sup = root.querySelector('#supplier_id');
				const cust = root.querySelector('#customer_id');
				const sync = () =>
				{
					const on = !!(ret && ret.checked);
					this.partyVisibilitySync(root);
					if (on && sup) sup.value = '';
					if (!on && cust) cust.value = '';
				};
				if (ret)
					ret.addEventListener('change', sync);
				this.partyVisibilitySync(root);
			}
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#reference' }, types: [types.caps()] },
		{ properties: { selector: '#created_on' }, types: [types.datetime()] },
		{ properties: { selector: '#created_by' }, types: [types.datalist()] },
		{ properties: { selector: '#updated_on' }, types: [types.datetime()] },
		{ properties: { selector: '#updated_by' }, types: [types.datalist()] },
		{ properties: { selector: '#supplier_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('suppliers', { labels: ['cnpj', 'nick'] })] },
		{ properties: { selector: '#customer_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('customers', { labels: ['cnpj', 'nick'] })] },
		{ properties: { selector: '#carrier_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('carriers', { labels: ['nick'] })] },
		{ properties: { selector: '#program_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('programs', { labels: ['name'] })] },
		{ properties: { selector: '#empenho_number' }, types: [types.caps(), types.empenho()] },
		{ properties: { selector: '#receipt_type_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('receipt_types', { labels: ['code', 'description'] })] },
		{ properties: { selector: '#freight_type' }, types: [types.opt_freight_type(), types.datalist()] },
		{ properties: { selector: '#freight_value' }, types: [types.number(2)] },
		{ properties: { selector: '#discount' }, types: [types.number(2)] },
		{ properties: { selector: '#notes' }, types: [types.textarea()] },
		{ properties: { selector: '#is_return' }, types: [types.checkbox()] },
		{ properties: { selector: '#status' }, types: [types.opt_input_order_status(), types.datalist()] },
		{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#product_id-0' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'], filter: r => !r.is_disabled })] },
		{ properties: { selector: '#unit_id-0' }, types: [types.pubsub(), types.datalist(), types.observer(['company_id', 'product_id-0']), types.obs_unit(1)] },
		{ properties: { selector: '#quantity-0' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#unit_price-0' }, types: [types.number(2)] },
	]

};

